var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',[(_vm.showNavBar)?_c('navigation'):_vm._e(),_c('router-view',{staticClass:"p-3"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }